import React, { Component } from "react";
import { Link } from "react-router-dom";
import API from "../../config/api";
import { exportToExcel } from "../Helper/exportToExcel";

import CustomModal from "../Bar/CustomModal";
import Pagination from "../Bar/Pagination";
import moment from 'moment';
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import * as XLSX from "xlsx";

class QuestionIndex extends Component {
  state = {
    data: null,
    s: '',
    page: 1,
    total: 0,
    total_categories: 0,
    questions: [],
    categories: [],
    image_url: null,
    limit: 100,
    excelData: [],
  }

  UNSAFE_componentWillMount() {
    this.getAllQuestions();
    this.getAllCategories();
    this.getImageLink();
  }

  componentDidMount() {
    // this.getParam("success");
    // toast.info("Welcome back to this screen!");
    // toast.success("Your action is successful", {
    //   data: {
    //     title: "Success toast",
    //     text: "This is a success message",
    //   },
    // })
  }

  getImageLink() {
    let url = API.getImage();
    this.state.image_url = url
    this.setState({})
  }

  getParam(name) {

    let success = window.location.search.split(`${name}=`)[1]
    if (success) {
      toast.success("Your action is successful", {
        data: {
          title: "Success toast",
          text: "This is a success message",
        },
      })
    }
  }

  getAllCategories = async () => {
    try {
      let query = `page=${this.state.page}`
      let results = await API.getAllCategory(query);
      let data = results.data;

      // this.setState({ categories : data.category, total_categories: data.total });
      this.setState({ categories: data.category });

    } catch (error) {
      console.log(error)
    }
  }

  getAllQuestions = async () => {
    try {
      let query = `page=${this.state.page}&s=${this.state.s}&limit=${this.state.limit}`
      let results = await API.getAllQuestions(query);

      let data = results.data.result;

      this.setState({ questions: data.quiz, total: data.total, limit: data.limit });
      // this.setState({ users : data.users, total: data.total, limit: data.limit  });

    } catch (error) {
      console.log(error)
    }
  }

  onSearch = async (event) => {
    // cateogory_id=1 , s=code,limit=100
    event.preventDefault();
    let value = event.target.value;
    this.state.s = event.target.value;
    try {
      let query = `s=${value}&page=${this.state.page}`
      let results = await API.getAllQuestions(query);

      let data = results.data.result;

      this.setState({ questions: data.quiz, total: data.total, limit: data.limit });

    } catch (error) {
      console.log(error)
    }
  }

  async updateTestAvailable(data) {
    await API.updateTestQuestion({
      id: data.id,
      test_available: data.test_available
    });
    this.getAllQuestions();
    toast.success("Your action is successful")

  }

  exportUsersToExcel = (data, filename) => {
    exportToExcel(data, filename);
  }

  handleFileUpload = async (event) => {
    // event.preventDefault();
    let dataExcel = [];

    const file = event.target.files[0];
    if (!file)
      return;
    const reader = new FileReader();

    reader.onload = async (e) => {
      const data = new Uint8Array(e.target.result);
      const workbook = XLSX.read(data, { type: "array" });

      // Assuming the first sheet is the one you want
      const worksheet = workbook.Sheets[workbook.SheetNames[0]];
      const jsonData = XLSX.utils.sheet_to_json(worksheet, { header: 1 });

      //filterout 1 row
      const filteredData = jsonData.slice(1);

      let file_data = [];
      let all_answers = [];

      filteredData.forEach((data, index) => {
        if (index != 0);
        // all_answers.push({text: data[8], text: data[9], text: data[10], text: data[11]})

        // for(let i=8 ; i< 12 ; i++) {
        //   all_answers.push({text: data[8], text: data[9], text: data[10], text: data[11]})
        // }
        if (data && data.length != 0) {
          file_data.push({
            // code: data[0] && data[0] !== undefined ?  data[0] : 0,
            code: data[0],
            level: data[2],
            category_id: data[3],
            topic: JSON.stringify({ question_topic: data[4], enable_bold: 0, enable_box: 0 }),
            // topic: JSON.stringify([
            //   {question_topic: data[4]},
            //   {enable_bold: false},
            //   {enable_box: false},
            // ]),
            name: data[5] + '.',
            question: data[6],

            answer: JSON.stringify([{ text: data[7] }, { text: data[8] }, { text: data[9] }, { text: data[10] }]),

            correct_answer: data[11],
          })
        }
      });

      // this.setState({ excelData: jsonData });

      try {
        let results = await API.postQuestion(file_data);

        if (results.result) {
          toast.success("Your action is successful", {
            data: {
              title: "Success toast",
              text: "This is a success message",
            },
          })
          this.getAllQuestions();
        }

      } catch (error) {
        console.log(error)
      }
    };

    reader.readAsArrayBuffer(file);
  }

  sort = () => {
    alert('In construction')
  }

  convertToText = (html) => {
    const doc = new DOMParser().parseFromString(html, 'text/html');
    return doc.body.textContent || "";
  };

  truncateString = (str, maxLength) => {
    if (!str) return;
    if (str.length > maxLength) {
      return str.substring(0, maxLength) + '...';
    }
    return str;
  };

  onPaginationPress = (page) => {
    this.state.page = page;
    this.getAllQuestions();
    this.setState({});
  }

  deleteQuiz = async (event) => {
    event.preventDefault();
    let data = {
      quiz_id: this.state.data.id
    }
    try {
      let results = await API.postDeleteQuestion(data);

      if (results.result) {
        toast.success("Your action is successful", {
          data: {
            title: "Success toast",
            text: "This is a success message",
          },
        })
        this.getAllQuestions();
      }

    } catch (error) {
      console.log(error)
    }
  }

  linkToNewPage = async (id) => {
    let element = document.getElementById(`clickview${id}`);
    element.click();
  }

  render() {
    return (
      <div className="col-12 ">
        <ToastContainer />
        <div className="card card-body card-hover-shadow p-40">
          <h4 className="card-title"><strong>Total Questions: <b className="text-success fw-500 w-80px"> {this.state.total.toLocaleString('en-US')}</b> <span className="fa fa-question"></span></strong></h4>
          <div className="card-body">
            <div className="flexbox mb-20">
              <div className="lookup">
                <input className="w-250px" type="text" name="s" placeholder="Search" onChange={this.onSearch} />
              </div>

              <div className="btn-toolbar">
                <div className="btn-group btn-group-sm">
                  {/* <Link to="/videonew" className="btn" title="Add new" data-provide="tooltip" > <i className="ion-plus-round"></i></Link> */}
                  <Link to="/questionedit" className="btn btn-primary" title="Add new" data-provide="tooltip" > <i className="ion-plus-round"></i></Link>
                  {/* <button class="btn btn-float btn-primary"><i class="ti-pencil"></i></button> */}
                </div>

                <div className="btn-group btn-group-sm ml-2 d-none d-sm-flex">
                  <button className="btn btn-info" onClick={(e) => {
                    e.preventDefault()
                    document.getElementById("importExcel").click()
                  }}><i class="fa fa-file-excel-o"></i> Import</button>

                  {/* <button className="btn btn-info dropdown-toggle" data-toggle="dropdown" onClick={(e) => {
                        e.preventDefault()
                        document.getElementById("importExcel").click()
                        }}>Import</button> */}
                  <div className="dropdown-menu dropdown-menu-right">
                    {/* <Link class="dropdown-item" onClick={this.sort} ><i class="fa fa-file-zip-o"></i> Zip</Link>
                        <Link class="dropdown-item" onClick={this.sort} ><i class="fa fa-file-pdf-o"></i> Image</Link> */}
                    <input
                      type="file"
                      accept=".xlsx, .xls"
                      onChange={this.handleFileUpload}
                      hidden
                      id="importExcel"
                    />
                    {/* <Link class="dropdown-item" onClick={(e) => {
                        e.preventDefault()
                        document.getElementById("importExcel").click()
                        }} ><i class="fa fa-file-excel-o"></i> Excel</Link> */}
                  </div>
                </div>
              </div>
            </div>

            <table className="table table-hover table-has-action">
              <thead>
                <tr>
                  <th>#</th>
                  {/* <th>Thumbnail</th> */}
                  {/* <th>Test</th> */}
                  <th>Name</th>
                  <th>Question</th>
                  {/* <th>Description Kh</th>
                      <th>Description En</th> */}
                  <th>Code</th>
                  <th>Category</th>
                  <th>Level</th>
                  {/* <th className="w-140px">Created Date</th> */}
                  <th className="text-center w-150px">Actions</th>
                </tr>
              </thead>
              <tbody>
                {
                  this.state.questions && this.state.questions.map((question, index) => {
                    return <tr>
                      <th onClick={() => this.linkToNewPage(question.id)} scope="row">{((this.state.page - 1) * this.state.limit) + (index + 1)}</th>
                      {/* <td><img style={{width: 30, height: 30, borderRadius: 30}} src={video.thumbnail_url} alt="video thumbnail" /></td> */}
                      {/* <td>
                          <div class="media">
                            <img class="avatar" src={question.image_url ? question.image_url : require('../../assets/assets_theme/img/avatar/1.jpg')} alt="..." />
                            <div class="media-body">
                              <p >{video.title_kh}</p>
                            </div>
                          </div>
                        </td> */}
                      {/* <td>
                          <input 
                            type="checkbox"
                            // defaultChecked={question.test_available}
                            checked={question.test_available ? true : false }
                            onChange={(e) => {
                              this.updateTestAvailable({
                                id: question.id,
                                test_available: e.target.checked? 1 : 0
                              })
                            }}
                          />
                        </td> */}
                      <td onClick={() => this.linkToNewPage(question.id)}>{this.truncateString(question.name, 60)}</td>
                      <td onClick={() => this.linkToNewPage(question.id)}>{this.truncateString(question.question, 60)}</td>
                      {/* <td>{question.question}</td> */}

                      {/* <td>{video.description_kh}</td>
                        <td>{video.description_en}</td> */}
                      <td onClick={() => this.linkToNewPage(question.id)} className="w-100px">{question.code}</td>
                      <td onClick={() => this.linkToNewPage(question.id)} className="w-100px">{this.state.categories.map((category, index) => {
                        if (category.id === question.category_id) {
                          return category.name
                        }

                      })}</td>
                      <td onClick={() => this.linkToNewPage(question.id)}>{question.level}</td>
                      {/* <td>{moment(question.created_at).format("DD-MMM-YYYY")}</td> */}
                      <td className="text-right table-actions">
                        <Link className="btn btn-square btn-round btn-primary" title="View" to={`/questionedit?id=${question.id}`}><i className="fa fa-eye"></i></Link>
                        <span>&nbsp;</span><Link className="btn btn-square btn-round btn-info" title="Edit" to={`/questionedit?id=${question.id}`}><i id={`clickview${question.id}`} className="ti-pencil"></i></Link>

                        {/* <span>&nbsp;</span><button title="Delete" onClick={(event) => this.deleteQuiz(event)} className="btn btn-square btn-round btn-danger"><i className='ti-trash'  ></i> </button> */}
                        <span>&nbsp;</span><Link title="Delete" onClick={() => this.setState({ data: question })} className="btn btn-square btn-round btn-danger"><i className='ti-trash' data-toggle="modal" data-target="#modal-center" ></i> </Link>

                        {/* <div className="dropdown table-action">
                            <span className="dropdown-toggle no-caret hover-primary" data-toggle="dropdown" title="More"><i class="ti-more-alt rotate-90"></i></span>
                            <div className="dropdown-menu dropdown-menu-right">
                              <a className="dropdown-item" href="/"><i class="ti-menu-alt"></i> Details</a>
                              <a className="dropdown-item" href="/"><i class="ti-clip"></i> Add file</a>
                              <a className="dropdown-item" href="/"><i class="ti-bar-chart"></i> Performance</a>
                            </div>
                          </div> */}
                      </td>
                    </tr>

                  })
                }
              </tbody>
            </table>
            {/* <Pagination 
                onPaginationPress={this.onPaginationPress}
                totalPageLength = {this.state.total}
                limit = {this.state.limit}
                selectPage = {this.state.page}
              /> */}
            <Pagination
              onPaginationPress={this.onPaginationPress}
              totalPageLength={this.state.total}
              limit={this.state.limit}
              selectPage={this.state.page}
            />
          </div>
        </div>

        {/* Modal */}
        {
          this.state.data &&
          <CustomModal
            data={this.state.data}
            title="Do you really want to delete this question?"
            deleteQuiz={this.deleteQuiz}
          />
        }
      </div>
    );
  }
}

export default QuestionIndex;
